<template>
  <SGPModalComponent tamanho="sm" titulo="Importar Usuários" @sgpModalFechar="$emit('fechar')" :mostrarFooter="false">
    <div>

      <template v-if="etapa === 'upload'">
        <p class="text-center mb-4" style="color: #555;">
          Realize a importação de usuários através de planilha padrão
        </p>

        <div class="d-flex justify-content-center gap-3 mb-4">
          <v-btn outlined color="primary" small @click="baixarModelo" :loading="baixandoModelo">
            <v-icon left small>mdi-download</v-icon>
            Baixar modelo
          </v-btn>

          <v-btn color="primary" small @click="$refs.fileInput.click()" :loading="importando">
            <v-icon left small>mdi-upload</v-icon>
            Importar arquivo
          </v-btn>
        </div>

        <input
          ref="fileInput"
          type="file"
          accept=".xlsx,.csv"
          style="display: none"
          @change="selecionarArquivo"
        />

        <div
          class="drop-zone"
          :class="{ 'drop-zone--over': arrastando }"
          @dragover.prevent="arrastando = true"
          @dragleave.prevent="arrastando = false"
          @drop.prevent="onDrop"
          @click="$refs.fileInput.click()"
        >
          <v-icon large color="grey">mdi-cloud-upload-outline</v-icon>
          <p class="mb-1 mt-2" style="font-size: 13px; color: #777;">
            Arraste o arquivo aqui ou clique para selecionar
          </p>
          <p v-if="arquivoSelecionado" class="mb-0 font-weight-medium" style="font-size: 13px; color: #333;">
            {{ arquivoSelecionado.name }}
          </p>
        </div>

        <p class="text-center mt-2 mb-0" style="font-size: 11px; color: #999;">
          Formatos aceitos: XLSX, CSV &nbsp;|&nbsp; Tamanho máximo: 5MB
        </p>

        <p v-if="erroUpload" class="text-center mt-2 mb-0 red--text" style="font-size: 12px;">
          {{ erroUpload }}
        </p>

        <div v-if="arquivoSelecionado" class="d-flex justify-content-center mt-4">
          <v-btn color="success" small @click="enviarArquivo" :loading="importando">
            Confirmar importação
          </v-btn>
        </div>
      </template>

      <template v-else-if="etapa === 'aguardando'">
        <div class="py-2">
          <div class="d-flex align-center mb-3">
            <v-progress-circular indeterminate color="primary" size="28" width="3" class="mr-3" />
            <span style="color: #555; font-size: 14px;">Processando importação...</span>
          </div>

          <div class="status-card mb-3">
            <div class="status-label">Status</div>
            <v-chip small :color="statusColor" dark>{{ statusLabel }}</v-chip>
          </div>

          <template v-if="statusImportacao.total_rows > 0">
            <div class="status-card mb-2">
              <div class="d-flex justify-space-between mb-1" style="font-size: 12px; color: #555;">
                <span>Progresso</span>
                <span>{{ statusImportacao.processed_rows }} / {{ statusImportacao.total_rows }} linhas</span>
              </div>
              <v-progress-linear
                :value="progressoPercent"
                color="primary"
                rounded
                height="8"
              />
            </div>

            <div class="d-flex" style="gap: 8px;">
              <div class="stat-box stat-box--success">
                <div class="stat-box__value">{{ statusImportacao.success_rows }}</div>
                <div class="stat-box__label">Sucesso</div>
              </div>
              <div class="stat-box stat-box--error">
                <div class="stat-box__value">{{ errosCount }}</div>
                <div class="stat-box__label">Erros</div>
              </div>
              <div class="stat-box stat-box--total">
                <div class="stat-box__value">{{ statusImportacao.total_rows }}</div>
                <div class="stat-box__label">Total</div>
              </div>
            </div>
          </template>
        </div>
      </template>

      <template v-else-if="etapa === 'concluido'">
        <div class="text-center mb-3">
          <v-icon :color="statusImportacao.errors && statusImportacao.errors.length ? 'warning' : 'success'" size="48">
            {{ statusImportacao.errors && statusImportacao.errors.length ? 'mdi-check-circle-outline' : 'mdi-check-circle-outline' }}
          </v-icon>
          <p class="mt-2 mb-1 font-weight-medium">Importação concluída</p>
        </div>

        <div class="d-flex mb-4" style="gap: 8px;">
          <div class="stat-box stat-box--success" style="flex: 1;">
            <div class="stat-box__value">{{ statusImportacao.success_rows }}</div>
            <div class="stat-box__label">Importados</div>
          </div>
          <div class="stat-box stat-box--error" style="flex: 1;">
            <div class="stat-box__value">{{ statusImportacao.errors ? statusImportacao.errors.length : 0 }}</div>
            <div class="stat-box__label">Erros</div>
          </div>
          <div class="stat-box stat-box--total" style="flex: 1;">
            <div class="stat-box__value">{{ statusImportacao.total_rows }}</div>
            <div class="stat-box__label">Total</div>
          </div>
        </div>

        <v-progress-linear
          :value="progressoConcluido"
          color="success"
          rounded
          height="8"
          class="mb-4"
        />

        <template v-if="statusImportacao.errors && statusImportacao.errors.length">
          <v-divider class="mb-3" />
          <p class="mb-2 font-weight-medium" style="font-size: 13px; color: #c62828;">
            {{ statusImportacao.errors.length }} linha(s) com erro:
          </p>
          <div style="max-height: 200px; overflow-y: auto;">
            <v-simple-table dense>
              <template #default>
                <thead>
                  <tr>
                    <th>Linha</th>
                    <th>Campo</th>
                    <th>Mensagem</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(erro, i) in statusImportacao.errors" :key="i">
                    <td>{{ erro.linha }}</td>
                    <td>{{ erro.campo }}</td>
                    <td>{{ erro.mensagem }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </template>

        <div class="d-flex justify-content-center mt-4" style="gap: 12px;">
          <v-btn outlined small @click="reiniciar">Nova importação</v-btn>
          <v-btn color="primary" small @click="$emit('concluido')">Fechar</v-btn>
        </div>
      </template>

      <template v-else-if="etapa === 'erro'">
        <div class="text-center py-4">
          <v-icon color="error" size="48">mdi-alert-circle-outline</v-icon>
          <p class="mt-2 mb-1 font-weight-medium red--text">Falha na importação</p>
          <p style="font-size: 13px; color: #555;">{{ mensagemErro }}</p>
          <v-btn outlined small class="mt-3" @click="reiniciar">Tentar novamente</v-btn>
        </div>
      </template>

    </div>
  </SGPModalComponent>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ImportarUsuariosModal',

  emits: ['fechar', 'concluido'],

  data() {
    return {
      etapa: 'upload',
      arrastando: false,
      arquivoSelecionado: null,
      erroUpload: null,
      importando: false,
      baixandoModelo: false,
      mensagemErro: '',
      statusImportacao: {
        status: 'pending',
        total_rows: 0,
        processed_rows: 0,
        success_rows: 0,
        errors: [],
      },
      pollingInterval: null,
    };
  },

  computed: {
    progressoPercent() {
      if (!this.statusImportacao.total_rows) return 0;
      return Math.round((this.statusImportacao.processed_rows / this.statusImportacao.total_rows) * 100);
    },

    progressoConcluido() {
      if (!this.statusImportacao.total_rows) return 100;
      return Math.round((this.statusImportacao.success_rows / this.statusImportacao.total_rows) * 100);
    },

    errosCount() {
      return this.statusImportacao.errors ? this.statusImportacao.errors.length : 0;
    },

    statusLabel() {
      const labels = {
        pending: 'Aguardando',
        processing: 'Processando',
        completed: 'Concluído',
        completed_with_errors: 'Concluído com erros',
        failed: 'Falhou',
      };
      return labels[this.statusImportacao.status] || this.statusImportacao.status;
    },

    statusColor() {
      const colors = {
        pending: 'grey',
        processing: 'primary',
        completed: 'success',
        completed_with_errors: 'warning',
        failed: 'error',
      };
      return colors[this.statusImportacao.status] || 'grey';
    },
  },

  beforeDestroy() {
    this.pararPolling();
  },

  methods: {
    ...mapActions('usuarios', ['importarUsuarios', 'verificarStatusImportacao', 'baixarModeloImportacao']),

    selecionarArquivo(event) {
      const arquivo = event.target.files[0];
      if (arquivo) this.validarEDefinirArquivo(arquivo);
      event.target.value = '';
    },

    onDrop(event) {
      this.arrastando = false;
      const arquivo = event.dataTransfer.files[0];
      if (arquivo) this.validarEDefinirArquivo(arquivo);
    },

    validarEDefinirArquivo(arquivo) {
      this.erroUpload = null;
      const extensoesAceitas = ['xlsx', 'csv'];
      const extensao = arquivo.name.split('.').pop().toLowerCase();

      if (!extensoesAceitas.includes(extensao)) {
        this.erroUpload = 'Formato inválido. Use XLSX ou CSV.';
        return;
      }

      if (arquivo.size > 5 * 1024 * 1024) {
        this.erroUpload = 'O arquivo excede o limite de 5MB.';
        return;
      }

      this.arquivoSelecionado = arquivo;
    },

    async enviarArquivo() {
      if (!this.arquivoSelecionado) return;

      this.importando = true;
      this.erroUpload = null;

      try {
        const formData = new FormData();
        formData.append('arquivo', this.arquivoSelecionado);

        const response = await this.importarUsuarios(formData);
        const jobId = response?.data?.data?.job_id;

        if (!jobId) throw new Error('Resposta inválida do servidor.');

        this.etapa = 'aguardando';
        this.iniciarPolling(jobId);
      } catch (error) {
        const mensagem = error?.response?.data?.message || error?.message || 'Erro ao enviar arquivo.';
        this.erroUpload = mensagem;
      } finally {
        this.importando = false;
      }
    },

    iniciarPolling(jobId) {
      this.pollingInterval = setInterval(async () => {
        try {
          const response = await this.verificarStatusImportacao(jobId);
          const status = response?.data?.data;

          if (!status) return;

          this.statusImportacao = status;

          const statusFinais = ['completed', 'completed_with_errors', 'failed'];
          if (statusFinais.includes(status.status)) {
            this.pararPolling();

            if (status.status === 'failed') {
              const primeiro = status.errors?.[0];
              this.mensagemErro = primeiro?.mensagem || 'Erro desconhecido durante a importação.';
              this.etapa = 'erro';
            } else {
              this.etapa = 'concluido';
            }
          }
        } catch {
          this.pararPolling();
          this.mensagemErro = 'Erro ao verificar status da importação.';
          this.etapa = 'erro';
        }
      }, 3000);
    },

    pararPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },

    async baixarModelo() {
      this.baixandoModelo = true;
      try {
        await this.baixarModeloImportacao();
      } finally {
        this.baixandoModelo = false;
      }
    },

    reiniciar() {
      this.etapa = 'upload';
      this.arquivoSelecionado = null;
      this.erroUpload = null;
      this.statusImportacao = {};
      this.mensagemErro = '';
    },
  },
};
</script>

<style scoped>
.drop-zone {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 24px 16px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
}

.drop-zone:hover,
.drop-zone--over {
  border-color: #1976d2;
  background: #f0f7ff;
}

.status-card {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 10px 12px;
}

.status-label {
  font-size: 11px;
  color: #888;
  margin-bottom: 4px;
}

.stat-box {
  border-radius: 8px;
  padding: 10px 8px;
  text-align: center;
  flex: 1;
}

.stat-box--success { background: #e8f5e9; }
.stat-box--error   { background: #ffebee; }
.stat-box--total   { background: #e3f2fd; }

.stat-box__value {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
}

.stat-box--success .stat-box__value { color: #2e7d32; }
.stat-box--error   .stat-box__value { color: #c62828; }
.stat-box--total   .stat-box__value { color: #1565c0; }

.stat-box__label {
  font-size: 11px;
  color: #666;
  margin-top: 2px;
}
</style>